import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import BrandLogo from "../components/common/BrandLogo";

export default function OAuthCallbackPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [status, setStatus] = React.useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = React.useState<string>("Conectando con el proveedor...");
  const [provider, setProvider] = React.useState<string | null>(null);

  React.useEffect(() => {
    let mounted = true;
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    const token = params.get("token");
    const providerParam = params.get("provider");
    const errorParam = params.get("error");
    if (providerParam) setProvider(providerParam);

    async function processToken() {
      if (statusParam === "success" && token) {
        try {
          await loginWithToken(token);
          if (!mounted) return;
          setStatus("success");
          setMessage("Autenticación completada. Redirigiendo al panel...");
          setTimeout(() => navigate("/dashboard"), 1200);
        } catch (error) {
          if (!mounted) return;
          setStatus("error");
          setMessage(error instanceof Error ? error.message : "No se pudo completar la autenticación");
        }
      } else {
        setStatus("error");
        setMessage(errorParam || "No se pudo completar la autenticación");
      }
    }

    processToken();

    return () => {
      mounted = false;
    };
  }, [location.search, loginWithToken, navigate]);

  return (
    <div
      className="app-container"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <header className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="brand">
            <BrandLogo size={30} />
          </Link>
        </div>
      </header>
      <main className="layout-main" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="panel" style={{ maxWidth: "480px", textAlign: "center" }}>
          {status === "loading" && (
            <div className="loader" style={{ justifyContent: "center" }}>
              <div className="spinner" />
              Conectando con {provider ?? "el proveedor"}...
            </div>
          )}
          {status === "success" && (
            <>
              <h1 className="section-title" style={{ fontSize: "1.75rem" }}>
                ¡Listo!
              </h1>
              <p className="section-subtitle">{message}</p>
              <p className="section-subtitle">
                Si la redirección no ocurre automáticamente, <Link to="/dashboard">haz clic aquí</Link>.
              </p>
            </>
          )}
          {status === "error" && (
            <>
              <h1 className="section-title" style={{ fontSize: "1.75rem", color: "#b91c1c" }}>
                Algo ha fallado
              </h1>
              <p className="section-subtitle">{message}</p>
              <Link to="/auth/login" className="btn btn-primary" style={{ alignSelf: "center" }}>
                Volver al login
              </Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
